module.exports = __webpack_public_path__ + "static/media/guy.0e650263.jpg";